const content = {
    twitter_data_upload: {
        en: {
            simple_summary_no_video_html: '',
            simple_steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>To upload your data, simply click <b>"Choose File"</b> below; find the ZIP file you saved and upload it.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Since some files are large, we recommend being connected to Wi-Fi so that the upload process is as fast as possible.</p>'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: '<p>PLEASE NOTE THAT WE USE A SECURE UPLOADING SERVICE TO PROTECT YOUR DATA AND PRIVACY.</p>'
                }
            ],
            data_type_description: 'X Data Upload',
            summary_no_video_html: '<p>This is the second part of the X data task. Please upload your X data file by following the instructions below:</p>',
            steps: [
            {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Open the <b>X</b> app on your phone.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Tap on your profile icon (top-left hand corner of your screen – it usually has your picture).</p>'
            },
            {
                step_type: 'numbered_step',
                number: '3',
                description_html: `<p>Tap on <b>Settings and Support</b>.</p>`
            },
            {
                step_type: 'numbered_step',
                number: '4',
                description_html: `<p>Tap on <b>Settings and Privacy</b>.</p>`
            },
            {
                step_type: 'numbered_step',
                number: '5',
                description_html: `<p>Tap on <b>Your Account</b>.</p>`
            },
            {
                step_type: 'numbered_step',
                number: '6',
                description_html: '<p>Tap on <b>Download an archive of your data</b>.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '7',
                description_html: '<p>Enter your password.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '8',
                description_html: '<p>Verify your identity using email or text message.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '9',
                description_html: '<p>Enter the passcode sent via email or text.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '10',
                description_html: '<p>Tap to download the archive (using the blue button).</p>'
            },
            {
                step_type: 'numbered_step',
                number: '11',
                description_html: '<p>Tap <b>Get Started</b>.</p>'
            },
            {
                step_type: 'numbered_step',
                number: '12',
                description_html: '<p>When you receive the download zip file – upload it using the upload button below.</p>'
            }
            ],
            part_1_instructions_link: 'https://help.measureprotocol.com/en/support/solutions/articles/80001128766-x-twitter-data-file-retro-instructions'
        },
        es: {
            simple_summary_no_video_html: '',
            simple_steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Para subir tus datos, simplemente haz clic en <b>"Elegir archivo"</b> abajo; encuentra el archivo ZIP que acabas de guardar y súbelo.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Dado que algunos archivos son grandes, te recomendamos estar conectado a Wi-Fi para que el proceso de subida sea lo más rápido posible.</p>'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: '<p>POR FAVOR, TEN EN CUENTA QUE UTILIZAMOS UN SERVICIO DE SUBIDA SEGURO PARA PROTEGER TUS DATOS Y TU PRIVACIDAD.</p>'
                }
            ],
            data_type_description: 'X Data Upload',
        },
        pt: {
            simple_summary_no_video_html: '',
            simple_steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Para fazer o upload dos seus dados, simplesmente clique em <b>"Escolher Arquivo"</b> em baixo — encontre o ficheiro ZIP que acabou de guardar e faça o upload do mesmo.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Como alguns ficheiros são grandes, sugerimos que esteja conectado ao Wi-Fi para tornar o processo de upload o mais rápido possível.</p>'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: '<p>POR FAVOR, NOTE QUE USAMOS UM SERVIÇO DE UPLOAD SEGURO PARA PROTEGER SEUS DADOS E A SUA PRIVACIDADE.</p>'
                }
            ],
            data_type_description: 'X Data Upload',
        }
    },
    twitter_activity_history: {
        en: {
            summary_no_video_html: `
            <h2>Before you start</h2> 
            <p>It’s important you complete each step, or we won’t be able to process your payment! Our
            instructions are easy to follow.</p>`,
            steps: [
                {
                step_type: 'numbered_step',
                number: '1',
                description_html: `<p>Tap <b>Start</b> to continue, where you will be redirected to Twitter.</p>`
                },
                {
                step_type: 'numbered_step',
                number: '2',
                description_html: `<p>Please review Twitter's terms of the access.</p>`
                },
                {
                step_type: 'numbered_step',
                number: '3',
                description_html: `<p>Click <b>Authorise App</b>.</p>`
                }
            ],
        },
    },
}

export const twitterDataTypes = {
    twitter_data_upload: {
        data_type: 'twitter_data_upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/twitter-activity-history/x.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.twitter_data_upload
        },
    },
    twitter_activity_history: {
        data_type: 'twitter_activity_history',
        capture_type: 'twitter',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/twitter-activity-history/x.png',
        data_type_description: 'Twitter History',
        generic: {
            ...content.twitter_activity_history
        }        
    },
}